import * as c from '@chakra-ui/react'
import React from 'react'
import { useCommonCard } from 'src/components/cards/property/common'
import { Gallery } from 'src/components/cards/property/gallery'
import {
  PropertyCardContext,
  PropertyCardProvider,
} from 'src/components/cards/property/property-card.context'
import FlagType from 'src/components/cards/property/search/flag'
import LikeButton from 'src/components/cards/property/search/like-button'

import MotionFees from './motion-fees'

export const Card = () => {
  const { property, clickRedirect } = React.useContext(PropertyCardContext)
  const { isOpen, onOpen, onClose } = c.useDisclosure()
  const {
    isOpen: isAnimate,
    onOpen: onStartAnimate,
    onClose: onEndAnimate,
    onToggle: onAnimateToggle,
  } = c.useDisclosure()

  const { gallery } = useCommonCard({
    property,
  })

  const handleStartAnimate = () => {
    onOpen()
    onStartAnimate()
  }

  const handleEndAnimate = () => {
    onClose()
    onEndAnimate()
  }

  return (
    <div
      style={{ width: '100%', WebkitTapHighlightColor: 'transparent' }}
      onTouchMove={handleStartAnimate}
      onMouseEnter={handleStartAnimate}
      onMouseLeave={handleEndAnimate}
    >
      <c.Flex
        bg="black.0"
        direction="column"
        borderRadius="20px"
        cursor="pointer"
      >
        <c.Box maxW="100%" pos="relative">
          <FlagType />
          <Gallery
            gallery={gallery as any}
            width="100%"
            height="200px"
            widthDesktop="100%"
            heightDesktop="200px"
            withIndicators
            swipeable={false}
            withArrows={true}
            imageProps={{
              style: {
                borderRadius: '20px 20px 0 0',
                width: '100%',
                height: '200px',
              },
            }}
            clickImage={clickRedirect}
          />
        </c.Box>
        <c.Flex
          onClick={clickRedirect}
          direction="column"
          gap="16px"
          padding="16px"
          width={['100%', null, '350px']}
        >
          <c.Flex direction="column" cursor="pointer">
            <c.Text fontWeight="bold" noOfLines={1}>
              {property?.aliasName}
            </c.Text>
            <c.Text fontSize="12px" color="black.400">
              {`${property?.address?.neighborhood.name}, ${property?.address?.state}`}
            </c.Text>
          </c.Flex>
          <c.Flex
            alignItems={['start', null, 'center']}
            justifyContent="space-between"
            direction={['column', null, 'row']}
            gap={['15px', null, 'none']}
          >
            <MotionFees
              onAnimateToggle={onAnimateToggle}
              isAnimate={isAnimate}
              isOpen={isOpen}
            />
            <LikeButton />
          </c.Flex>
        </c.Flex>
      </c.Flex>
    </div>
  )
}

export const ApartmentCard = (props) => {
  return (
    <PropertyCardProvider {...props}>
      <Card />
    </PropertyCardProvider>
  )
}
